export const API = 'https://api.unsplash.com';
export const EDITORIAL_COLLECTION = '317099';
export const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;